/* This file is autogenerated, see readme.md for instructions */
import MultiParentUnassignedSvgIcon from '@bloomreach/banana-theme/icons/multi-parent-unassigned.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const MultiParentUnassignedIcon = forwardRef(
  (props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
    return (
      <Icon {...props} ref={forwardedRef}>
        <MultiParentUnassignedSvgIcon />
      </Icon>
    );
  },
);

MultiParentUnassignedIcon.displayName = 'MultiParentUnassignedIcon';

export default MultiParentUnassignedIcon;
